<template>
  <f7-page id="inbox"
    class="page-on-center rowBackgroundHomepage"
    data-page="inbox-page"
    :pull-to-refresh="isSmartphoneOS" @ptr:refresh="onRefresh(false)"
    infinite-scroll @infinite="onInfinite">

    <div class="layoutTop"></div>

    <div class="listPage" style="overflow:hidden;">
      <b-row class="form-group justify-content-start showLargeScreenOnly">
        <b-col sm="2">
          <f7-button class="button-action milkyBlockBlack" :disabled="activateSpinner"
            @click="refreshInbox()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
          </f7-button>
        </b-col>
        <b-col sm="2">
          <f7-button class="button-action milkyBlockBlack"
            href="/verifications/create/">
            <f7-icon f7="add"></f7-icon>
            <span>{{ 'Vérifier' }}</span>
          </f7-button>
        </b-col>
        <!-- <b-col sm="2">
          <f7-button class="button-action milkyBlockBlack" :disabled="activateSpinner"
            @click="exportVerifications()">
            <f7-icon f7="cloud_download"></f7-icon>
            <span class="fab-label">{{ $t('common.exprt') }}</span>
          </f7-button>
        </b-col> -->
      </b-row>

      <b-row>
        <b-col md="12">
          <div class="requestsList">
            <div>
              <cm-messages-filter
                class="researchfilter"
                style="position:relative;z-index:10"
                isVerifications
                filterType="list"
                :mode="this.mode"
                :randomId="randomId"
                @applyFilter="applyFilter($event)">
              </cm-messages-filter>
            </div>
            <div style="margin-top:0">
              <spinner v-if="activateSpinner"></spinner>
              <div v-else style="overflow-x:auto;">
                <table class="sellersResults">
                  <thead>
                    <th class="text-center" style="width:200px">
                      {{ 'Date' }}
                    </th>
                    <th class="text-center" style="width:200px">
                      {{ 'SIREN' }}
                    </th>
                    <th class="text-center" style="width:200px">
                      {{ 'SIRET' }}
                    </th>
                    <th class="text-center" style="width:400px">
                      {{ 'Dénomination' }}
                    </th>
                    <th class="text-center" style="width:255px">
                      {{ 'Statut' }}
                    </th>
                    <th class="text-center" style="width:80px">
                      {{ 'Actions' }}
                    </th>
                  </thead>
                  <tbody>
                    <template v-if="inboxMessages.length > 0">
                      <tr v-for="(result, index) in inboxMessages" :key="index"
                        class="boxRequest">
                        <td class="text-center" :title="result.DateVerifications">{{ result.DateVerifications }}</td>
                        <td class="text-center" :title="result.Siren">{{ result.Siren }}</td>
                        <td class="text-center" :title="result.Siret">{{ result.Siret }}</td>
                        <td class="text-center" :title="result.SocialReason">{{ result.SocialReason }}</td>
                        <td class="text-center" :title="getKYCVerificationsStatus(result.Status)">
                          <b-container fluid>
                            <b-row>
                              <b-col sm="2">
                                <i class="icon list-icon" :class="getKYCVerificationsIcon(result.Status)"></i>
                              </b-col>
                              <b-col sm="10" style="padding-top:5px;">
                                <span style="margin-left:-50px;">{{ getKYCVerificationsStatus(result.Status) }}</span>
                              </b-col>
                            </b-row>
                          </b-container>
                        </td>
                        <td>
                          <span class="fileClickButton"
                            @click="redirectDetails(result)">
                            {{ $t('common.cnslt') }}
                          </span>
                        </td>
                      </tr>
                    </template>

                    <tr v-else>
                      <td colspan="6" class="noResult">
                        {{ $t('common.no_result') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import moment from 'moment'

import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { statusIcon, statusLabel } from '@/helpers/labels'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'VerificationsListPage',
  components: {
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      activateSpinner: false,
      filterBy: '',
      inboxMessages: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Vérifications',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: this.direction})

    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.history.filter.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions) {
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      this.$engine.verifications.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.actionHistory.length
        requests = resp.data.actionHistory
        this.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportVerifications () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Date' + ';' +
        'Type d\'action' + ';' +
        'Utilisateur' + ';' +
        'Identifiant' + ';' +
        'Détails' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.inboxMessages.length; i++) {
        let result = this.inboxMessages[i]
        console.log(result.details)
        console.log(result.details.split('. '))
        lines += result.dateAction + ';' +
                 result.typeAction + ';' +
                 result.user + ';' +
                 result.endToEndId + ';' +
                 '"' + result.details.split('. ').join('.\r\n') + '"' + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'history_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    getKYCVerificationsIcon (status) {
      return statusIcon('KYCVerifications_' + status)
    },
    getKYCVerificationsStatus (status) {
      return statusLabel(this.$i18n, 'KYCVerifications_' + status)
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.verifications.filter.getDefaultFilter()) {
          filterConditions = this.$engine.verifications.filter.getDefaultFilter()
        } else {
          filterConditions = this.$engine.verifications.filter.getConditionObject()
        }
        this.$engine.verifications.update(
          this.direction,
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.actionHistory.length
          requests = resp.data.actionHistory
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.inboxMessages.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      // const that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      // if (this.$engine.history.filter.getDefaultFilter()) {
      //   filterConditions = this.$engine.verifications.filter.getDefaultFilter()
      // } else {
      //   filterConditions = this.$engine.verifications.filter.getConditionObject()
      // }
      this.$engine.services.verifications.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.KYCVerificationsHistory.length
        requests = resp.data.KYCVerificationsHistory
        for (var i = 0; i < requests.length; i++) {
          requests[i].DateVerifications = moment(requests[i].DateVerifications).format('DD/MM/yyyy HH:mm:ss')
          requests[i].Status = '1'
          for (var j = 0; j < requests[i].CodeList.length; j++) {
            let code = requests[i].CodeList[j].Code
            if ((requests[i].Status === '1' || requests[i].Status === '2' || requests[i].Status === '3') &&
              (code === '00000' || code === '00020' || code === '01000' || code === '01010' || code === '14000')) {
              requests[i].Status = '4'
            } else if ((requests[i].Status === '1' || requests[i].Status === '2') &&
              (code === '03000' || code === '12000' || code === '10010' || code === '10020' || code === '11010' || code === '13000')) {
              requests[i].Status = '3'
            } else if (requests[i].Status === '1' &&
              (code === '10010' || code === '10020' || code === '10030' || code === '11010' || code === '13000')) {
              requests[i].Status = '2'
            } else if (requests[i].Status === '1') {
              requests[i].Status = '1'
            }
          }
        }
        this.updateInbox(requests, noAttach)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    redirectDetails (entity) {
      entity.verify = false
      this.$engine.services.suppliers.selectedEntity = entity
      loadPage(this, { url: '/verifications/details/' })
    },
    refreshInbox () {
      this.onRefresh()
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    }
  }
}
</script>

<style scoped>
.sellersResults {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  width: 100%;
}

.sellersResults th {
  background-color: black;
  border: 1px solid silver;
  color: white;
  font-weight: normal;
  height: 40px;
}

.sellersResults tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.sellersResults tbody tr td,.sellersResults thead th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// VerificationsListPage.vue?0e018777